export const PAGE_TITLE = "Causes";
export const PAGE_SINGLE_TITLE = "Cause";
export const LINK_URL = "causes";
export const SEARCH_TERMS = ["name"];
export const inputFields = {
  name: {
    type: "string",
    required: true,
    title: "Name",
    slug: true,
    inputType: "text",
  },
  age: {
    type: "string",
    required: true,
    title: "Age",
  },
  disease: {
    type: "string",
    required: false,
    title: "Disease",
  },
  content: {
    type: "html",
    required: false,
    title: "Content",
  },
  featured_image: {
    type: "file",
    required: false,
    title: "Image",
  },
  gallery: {
    type: "gallery",
    required: false,
    title: "Document",
  },
  meta_title: {
    type: "string",
    required: false,
    title: "Meta Title",
  },
  meta_description: {
    type: "text",
    required: false,
    title: "Meta Description",
  },
  slug: {
    type: "slug",
    required: false,
    targetField: "title",
    title: "Slug",
  },
};
export const initialValues = {
  name: "",
  age: "",
  disease: "",
  content: "",
  meta_title: "",
  meta_description: "",
  slug: "",
};

export const view_all_table = [
  { name: "Name", value: "name" },
  { name: "Age", value: "age" },
  { name: "Disease", value: "disease" },
  { name: "Slug", value: "slug" },
];
